export default "__VITE_ASSET__5$QhAD3E__"